module.exports = __webpack_public_path__ + "static/media/edit.6ad539b6.svg";